const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getApiUrl = () => {
    // Remove trailing slash if present
    const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    
    // If the baseUrl already includes /api, don't add it again
    if (baseUrl.endsWith('/api')) {
        return baseUrl;
    }
    
    // For local development or if /api is not in the URL
    return `${baseUrl}/api`;
};

export default {
    getApiUrl
}; 